import React, { Component } from 'react';
import SideBarContainer from '../../SideBarContainer/SideBarContainer';
import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import { bindActionCreators } from 'redux';
import * as Constants from '../../../utilities/constants/Constants';
import FabricCanvas from './FabricCanvas/FabricCanvas';
import DimensionTemplate from '../../../components/DimensionTemplate/DimensionTemplate';
import ThreeDComponent from '../ThreeDComponent/ThreeDComponent';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as wallHandler from '../../../redux/actions/wallHandler';
import './DesignComponent.scss';
import './FabricCanvas/FabricCanvas.scss';
import InitialLoader from '../../../components/LoadingTemplate/InitialLoader';
import { Icons } from '../../../utilities';
import { Tooltip } from 'reactstrap';
import { string } from '../../../localization';
import MediaQuery from 'react-responsive';
import { isSignageSuiteProduct } from '../../../utilities/HelperFunctions/HelperFunctions';
import { SketchPicker } from 'react-color';
import Draggable from 'react-draggable';
import { Label, Input } from 'reactstrap';
import { fabric } from 'fabric';
import ToggleViewModeButton from '../../../components/ToggleViewModeButton/ToggleViewModeButton';
import TemplateSelectionDialogueIn2D from '../../../components/TemplateSelectionDialogues/TemplateSelectionDialogueIn2D';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import { MenuProvider } from 'react-contexify';

class DesignComponent extends Component {
  state = {
    showBlockChainTooltip: false,
    pickerColor: '#ffffff',
    colorIndex: 0
  };

  componentDidMount() {
    const { dispatchers, envData, viewType } = this.props;
    if (isSignageSuiteProduct()) {
      if (envData.is_sticker_type) {
        dispatchers.fabricCanvasActions.setViewType(
          Constants.EDIT_WORKSPACE_TYPE
        );
      } else {
        dispatchers.fabricCanvasActions.setViewType(Constants.THREE_D_TYPE);
        dispatchers.fabricCanvasActions.setInitialLoader(true);
      }
    }
    if (dispatchers.homeActions.checkIfCanvasApp() && !viewType) {
      dispatchers.fabricCanvasActions.setViewType(Constants.THREE_D_TYPE);
    }
    fabric.util.addListener(document.body, 'mousedown', this.handleAppClick);
  }

  componentDidUpdate(prevProps) {
    const { dispatchers, activeObject } = this.props;
    const { pickerColor } = this.state;
    let pickerColorValue = pickerColor;

    if (prevProps.activeObject !== activeObject) {
      dispatchers.sideBarActions.resetColorPickerSource();
      if (
        activeObject &&
        Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
        activeObject.placing.placeable.svgColors &&
        activeObject.placing.placeable.svgColors.length > 0
      ) {
        const rgb = activeObject.placing.placeable.svgColors[0];
        pickerColorValue = `#${rgb}`;
      } else if (
        activeObject &&
        Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
        activeObject.placing.placeable.colors &&
        activeObject.placing.placeable.colors.length > 0
      ) {
        pickerColorValue = `#${activeObject.placing.placeable.colors[0]}`;
      }
      this.setState({
        pickerColor: pickerColorValue,
        colorIndex: 0
      });
    }
  }

  viewModeIsChanged = id => {
    const { envData, dispatchers } = this.props;
    let viewMode;
    switch (id) {
      case Constants.SWITCH_VIEW_MODE.FIRST_OPTION:
        if (envData.is_sticker_type) {
          viewMode = Constants.EDIT_WORKSPACE_TYPE;
        } else {
          viewMode = Constants.THREE_D_TYPE;
        }
        break;
      case Constants.SWITCH_VIEW_MODE.SECOND_OPTION:
        if (envData.is_sticker_type) {
          viewMode = Constants.VISUALIZE_TYPE;
        } else {
          viewMode = Constants.TWO_D_TYPE;
        }
        break;

      default:
        break;
    }
    dispatchers.fabricCanvasActions.setViewMode(viewMode);
  };

  handleAppClick = e => {
    const { colorPickerSource, dispatchers } = this.props;
    if (e.target) {
      if (
        !(this.node != undefined && this.node.contains(e.target)) &&
        colorPickerSource
      ) {
        dispatchers.sideBarActions.resetColorPickerSource();
      }
    }
  };

  onPointerChange = color => {
    this.setState({ pickerColor: color.hex });
  };

  setColorIndex = (index, item) => {
    this.setState({ colorIndex: index, pickerColor: `#${item}` });
  };

  onUpdateRecolorList = () => {
    const { activeObject, dispatchers } = this.props;
    const { colorIndex, pickerColor } = this.state;

    let newRecolorArray = [];
    if (Object.prototype.hasOwnProperty.call(activeObject, 'placing')) {
      if (
        activeObject.placing.placeable.svgColors &&
        activeObject.placing.placeable.svgColors.length > 0
      ) {
        newRecolorArray = Array.from(activeObject.placing.placeable.svgColors);
        newRecolorArray[colorIndex] = pickerColor.substring(1).toUpperCase();
      } else {
        newRecolorArray = Array.from(activeObject.placing.placeable.colors);
        newRecolorArray[colorIndex].hex = pickerColor
          .substring(1)
          .toUpperCase();
      }
      dispatchers.sideBarActions.setDocumentColors(
        pickerColor.substring(1).toUpperCase()
      );
      dispatchers.fabricCanvasActions.updateElementWithColorsArray(
        newRecolorArray
      );
    }
  };

  pikerAddColorIsClicked = () => {
    const { colorPickerSource, dispatchers } = this.props;
    const { pickerColor } = this.state;

    switch (colorPickerSource) {
      case Constants.PATTERN_COLOR:
        dispatchers.sideBarActions.setPatternSearchColor(pickerColor);
        break;
      case Constants.SHADOW_COLOR:
        dispatchers.sideBarActions.pickShadowColor(pickerColor);
        break;
      case Constants.TEXT_COLOR:
        dispatchers.sideBarActions.setDocumentColors(pickerColor);
        break;
      case Constants.DOCUMENT_COLOR:
        dispatchers.sideBarActions.setDocumentColors(pickerColor);
        break;
      case Constants.RECOLOR:
        // dispatchers.sideBarActions.setColorToRecolor(
        //   pickerColor
        // );
        this.onUpdateRecolorList();
        break;
      case Constants.SOLID_COLOR:
        dispatchers.sideBarActions.setCanvasFrameColor(pickerColor);
        break;
      default:
        break;
    }
    dispatchers.sideBarActions.resetColorPickerSource();
  };

  getColorPickerTitle = source => {
    if (source === Constants.PATTERN_COLOR) {
      return string.PATTERN_COLOR_KEY;
    }
    if (source === Constants.SHADOW_COLOR) {
      return string.TEXT_SHADOW_COLOR_KEY;
    }
    if (source === Constants.TEXT_COLOR) {
      return string.TEXT_COLOR_KEY;
    }
    if (source === Constants.SOLID_COLOR) {
      return string.SOLID_COLOR_KEY;
    }
    if (source === Constants.RECOLOR) {
      return string.REOLOR_KEY;
    }
    if (source === Constants.DOCUMENT_COLOR) {
      return string.DOCUMENT_COLORS;
    }
    return '';
  };

  getBackground2DColor = () => {
    const { viewType, backgroundContrast } = this.props;
    let colorHexa =
      backgroundContrast === 'dark'
        ? Constants.DARK_CONTRAST_COLOR
        : Constants.NORMAL_WALL_COLOR;

    if (isSignageSuiteProduct()) {
      if (viewType == Constants.TWO_D_TYPE) {
        colorHexa = Constants.BLACK_COLOR;
      } else if (viewType == Constants.EDIT_WORKSPACE_TYPE) {
        colorHexa = Constants.STICKER_WORKSPACE_COLOR;
      }
    }
    let colorString = '#';
    if (colorHexa) {
      colorString += colorHexa;
    }
    return colorString;
  };

  renderColorPicker = () => {
    const {
      colorPickerSource,
      activeObject,
      dispatchers,
      documentColors
    } = this.props;

    const { colorIndex, pickerColor } = this.state;
    let objectColorList = [];
    if (
      activeObject &&
      Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
      activeObject.placing.placeable.svgColors &&
      activeObject.placing.placeable.svgColors.length > 0
    ) {
      objectColorList = activeObject.placing.placeable.svgColors;
    } else if (
      activeObject &&
      Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
      activeObject.placing.placeable.colors &&
      activeObject.placing.placeable.colors.length > 0
    ) {
      activeObject.placing.placeable.colors.forEach(colorDict => {
        objectColorList.push(colorDict.hex);
      });
    }

    return (
      <Draggable cancel='.undraggable'>
        <div
          id='color-picker'
          ref={node => {
            this.node = node;
          }}
        >
          <div className='header'>
            <p>{this.getColorPickerTitle(colorPickerSource)}</p>
            <input
              type='image'
              onClick={() => {
                dispatchers.sideBarActions.resetColorPickerSource();
              }}
              className='img'
              style={{ outline: 'none' }}
              src={Icons.closeDefault}
              alt='Close'
            />
          </div>
          {colorPickerSource === Constants.RECOLOR ? (
            <div className='recolor-container'>
              {objectColorList.map((item, index) => {
                const color = `#${item}`;
                return (
                  <div>
                    <div className='recolor-list'>
                      <div className='pt-1'>
                        {' '}
                        {string.formatString(string.HEX_COLOR_KEY, item)}
                        {/* {string.HEX_COLOR_KEY} {item} */}
                      </div>
                      <button
                        type='button'
                        aria-label='color'
                        className={`color-box ${
                          index === colorIndex ? 'selected-color' : null
                        }`}
                        style={{ backgroundColor: color }}
                        onClick={() => this.setColorIndex(index, item)}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
          <div className='undraggable'>
            <SketchPicker
              disableAlpha
              color={pickerColor}
              onChangeComplete={this.onPointerChange}
            />
          </div>
          {colorPickerSource === Constants.RECOLOR &&
          documentColors.length > 0 ? (
            <div id='recolor-pane' className='undraggable'>
              <div style={{ marginBotton: '6px' }}>
                <text className='document-pane-label'>
                  {string.DOCUMENT_COLORS}
                </text>
              </div>
              {documentColors.map(color => (
                <Label check key={color}>
                  <Input
                    type='radio'
                    name='textColors'
                    value={color}
                    onClick={() => this.onPointerChange({ hex: color })}
                  />
                  <div className='recolor-Box' style={{ background: color }} />
                </Label>
              ))}
            </div>
          ) : null}
          <div className='footer'>
            <button
              type='button'
              className={
                colorPickerSource === Constants.RECOLOR
                  ? 'recolor-buttons cancel'
                  : 'cancel-text'
              }
              onClick={() => {
                dispatchers.sideBarActions.resetColorPickerSource();
              }}
            >
              {string.CANCEL_TEXT_KEY}
            </button>
            <button
              type='button'
              onClick={() => this.pikerAddColorIsClicked()}
              className={
                colorPickerSource === Constants.RECOLOR
                  ? 'recolor-buttons apply'
                  : 'add-button add-color '
              }
            >
              {colorPickerSource === Constants.RECOLOR
                ? string.APPLY_KEY
                : string.ADD_COLOR_STRING_KEY}
            </button>
          </div>
        </div>
      </Draggable>
    );
  };

  renderCanvasArea = () => {
    const { dispatchers, colorPickerSource } = this.props;
    const colorString = this.getBackground2DColor();

    let canvasContents;
    if (isSignageSuiteProduct()) {
      canvasContents = this.renderCanvasForSignageSuiteProduct();
    } else {
      canvasContents = this.renderCanvasForPoster();
    }

    const colorPickerContents = colorPickerSource
      ? this.renderColorPicker()
      : null;

    return (
      <MenuProvider
        id='menu_id'
        style={{
          border: '0px solid white',
          top: '35px',
          left: '35px'
        }}
      >
        <div
          className={
            dispatchers.sideBarActions.shouldHideSidebarInDesktopMode()
              ? 'w-100 h-100'
              : 'playground-wrapper'
          }
          id='root-playground'
          style={{ backgroundColor: colorString }}
        >
          {colorPickerContents}
          {canvasContents}
        </div>
      </MenuProvider>
    );
  };

  renderCanvasForSignageSuiteProduct = () => {
    const {
      viewType,
      dispatchers,
      initialLoader,
      envData,
      selectedProduct,
      wallIndex
    } = this.props;
    const { showBlockChainTooltip } = this.state;
    return (
      <>
        <div
          style={
            viewType === Constants.THREE_D_TYPE
              ? { height: '100%', width: '100%' }
              : { display: 'none' }
          }
        >
          <ThreeDComponent />
          {dispatchers.fabricCanvasActions.checkForBlockChainTransaction()
            ? this.renderBlockChain()
            : null}

          {showBlockChainTooltip ? (
            <Tooltip
              id='blockchain-tooltip'
              className='arrow-color'
              placement='top'
              isOpen={showBlockChainTooltip}
              target='tooltip-blockchain'
            >
              {string.BLOCKCHAIN_STRING}
              <br />
              {string.CERTIFICATE_STRING}
              <br />
              {string.AUTHENTICITY_STRING}
            </Tooltip>
          ) : null}
        </div>
        <div style={{ width: '100%', height: '100%' }}>
          {dispatchers.fabricCanvasActions.isVisualizeModeActive() ? (
            <ToggleViewModeButton
              viewType={viewType}
              clickHandler={() => {
                if (viewType == Constants.THREE_D_TYPE) {
                  dispatchers.fabricCanvasActions.setViewMode(
                    Constants.TWO_D_TYPE
                  );
                } else if (viewType == Constants.TWO_D_TYPE) {
                  dispatchers.fabricCanvasActions.setViewMode(
                    Constants.THREE_D_TYPE
                  );
                }
              }}
            />
          ) : null}
          {dispatchers.wallHandler.canShowtemplateSelectionDialogueIn2D() ? (
            <TemplateSelectionDialogueIn2D
              templates={selectedProduct.activeProductSize.templates}
              activeIndex={wallIndex}
              clickHandler={index =>
                dispatchers.wallHandler.selectWallWithIndex(index)
              }
            />
          ) : null}

          <FabricCanvas />
          <DimensionTemplate
            sidebarIsHiddenInDesktop={dispatchers.sideBarActions.shouldHideSidebarInDesktopMode()}
            clickHandler={id => {
              this.viewModeIsChanged(id);
            }}
            isSticker={envData.is_sticker_type}
            viewType={viewType}
          />
          {initialLoader ? <InitialLoader /> : null}
        </div>
      </>
    );
  };

  renderCanvasForPoster = () => {
    const { dispatchers, envData, viewType } = this.props;
    return (
      <>
        <FabricCanvas />
        {dispatchers.homeActions.checkIfCanvasApp() ? (
          <DimensionTemplate
            sidebarIsHiddenInDesktop={dispatchers.sideBarActions.shouldHideSidebarInDesktopMode()}
            clickHandler={id => {
              this.viewModeIsChanged(id);
            }}
            isSticker={envData.is_sticker_type}
            viewType={viewType}
            isCanvas
          />
        ) : null}
      </>
    );
  };

  renderBlockChain = () => (
    <div
      className='block-chain-view'
      id='tooltip-blockchain'
      onMouseEnter={() => this.mouseEnter()}
      onMouseLeave={() => this.mouseLeave()}
    >
      <img
        className='block-chain-image'
        src={Icons.blockchain_white_icon}
        alt='block-chain-icon'
      />
    </div>
  );

  mouseEnter = () => {
    this.setState({ showBlockChainTooltip: true });
  };

  mouseLeave = () => {
    this.setState({ showBlockChainTooltip: false });
  };

  render() {
    const { showSideBar, dispatchers } = this.props;

    return (
      <ErrorBoundary>
        <div className='design-component-wraper'>
          <MediaQuery query='(min-width: 767px)'>
            {!dispatchers.sideBarActions.shouldHideSidebarInDesktopMode() ? (
              <SideBarContainer />
            ) : null}
          </MediaQuery>
          <MediaQuery query='(max-width: 767px)'>
            <div
              style={{ height: '100%' }}
              className='position-relative'
              id='design-component'
            >
              <div className={showSideBar ? 'drawer-fadeIn' : 'drawer-fadeOut'}>
                <SideBarContainer />
              </div>
            </div>
          </MediaQuery>
          {this.renderCanvasArea()}
        </div>
      </ErrorBoundary>
    );
  }
}

function mapStateToProps(state) {
  return {
    viewType: state.fabricCanvas.viewType,
    selectedProduct: state.home.selectedProduct,
    initialLoader: state.fabricCanvas.initialLoader,
    envData: state.modal.envData,
    showSideBar: state.sideBar.showSideBar,
    refresh: state.home.viewOnlyMode,
    colorPickerSource: state.sideBar.colorPickerSource,
    activeObject: state.fabricCanvas.activeObject,
    wallIndex: state.finalCheck.project.wallIndex,
    documentColors: state.sideBar.documentColors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      wallHandler: bindActionCreators(wallHandler, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DesignComponent);
